<template>
  <div class="download-links" v-if="links && links.length">
    <div class="download-links__inner">
      <download-link v-for="(link, index) in links" :id="'p-' + link.id" :link="link" :key="index" />
    </div>
  </div>
</template>

<script>
  import DownloadLink from '~/components/product/DownloadLink.vue';

  export default {
    components: {
      DownloadLink
    },
    props: {
      links: {
        default() {
          return [];
        },
        type: Array
      }
    }
  };
</script>
